import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { NavigationContext } from '../contexts/NavigationContext';

const useUpdateBreadcrumbs = (getBreadcrumbs) => {
  const location = useLocation();
  const { updateBreadcrumbs } = useContext(NavigationContext);
  const prevCrumbsRef = useRef(null);

  useEffect(() => {
    const newCrumbs = getBreadcrumbs(location.search);
    // Если новые крошки отличаются от предыдущих, обновляем
    if (JSON.stringify(newCrumbs) !== JSON.stringify(prevCrumbsRef.current)) {
      updateBreadcrumbs(newCrumbs);
      prevCrumbsRef.current = newCrumbs;
    }
  }, [location.search, updateBreadcrumbs, getBreadcrumbs]);
};

export default useUpdateBreadcrumbs;
